/**
 * Document-relative URL for a file copied from `public/` into the game bundle.
 *
 * `HTMLAudioElement.src` resolves against the page URL. With Vite `base: './'`,
 * a nested host such as `.../game/index.html` therefore loads `.../game/audio/...`.
 * A root-absolute bundle path ignores that base and fails on CrazyGames.
 */
export function bundleAssetUrl(directory: string, filename: string): string {
  const dir = directory.replace(/^\/+|\/+$/g, '');
  const asset = `${dir}/${encodeURIComponent(filename)}`;
  const base = import.meta.env.BASE_URL || './';
  if (base === './' || base === '.' || base === '/' || base === '') {
    return asset;
  }
  if (base.startsWith('/')) {
    return asset;
  }
  const prefix = base.endsWith('/') ? base : `${base}/`;
  return `${prefix}${asset}`;
}
